import React from 'react';
import PropTypes from 'prop-types';
import { KeyboardArrowLeft } from '@material-ui/icons';
import { t } from 'ttag';
import useStyles from '../../BacNetMapping/styles';

const BackButton = ({ onClick }) => {

  const classes = useStyles();

  return (
    <div className={classes.backBtnWrapper}>
      <button onClick={onClick} className={classes.backBtn}>
        <KeyboardArrowLeft />
        <span>{t`Back`}</span>
      </button>
    </div>
  );
};

BackButton.propTypes = {};

export default BackButton;
